import React, { Component } from "react";
import { connect } from "react-redux";
import { Link } from "react-router-dom";
import { getRecentBlogs } from "../../store/actions/blog";
import { PUBLIC_URL } from "../../config";

class BlogWidget extends Component {
  componentDidMount() {
    var recentBlogs = this.props.blog && this.props.blog.recentBlogs;
    if (!recentBlogs || recentBlogs.length === 0) {
      this.props.getRecentBlogs(5);
    }
  }

  formatDate(dateStr) {
    if (!dateStr) return "";
    var date = new Date(dateStr);
    var months = [
      "Ocak", "Şubat", "Mart", "Nisan", "Mayıs", "Haziran",
      "Temmuz", "Ağustos", "Eylül", "Ekim", "Kasım", "Aralık"
    ];
    return date.getDate() + " " + months[date.getMonth()] + " " + date.getFullYear();
  }

  render() {
    var recentBlogs = (this.props.blog && this.props.blog.recentBlogs) || [];

    if (recentBlogs.length === 0) return null;

    return (
      <div style={{
        backgroundColor: "#fff",
        border: "1px solid #eee",
        borderRadius: 8,
        padding: 20,
        marginBottom: 20,
      }}>
        <h6 style={{
          fontWeight: 700,
          marginBottom: 15,
          paddingBottom: 10,
          borderBottom: "2px solid #88c000",
          textTransform: "uppercase",
          letterSpacing: 1,
          fontSize: 14,
        }}>
          Blog Yazıları
        </h6>
        {recentBlogs.slice(0, 4).map(function(blog) {
          return (
            <div key={blog.id} style={{
              marginBottom: 12,
              paddingBottom: 12,
              borderBottom: "1px solid #f0f0f0",
            }}>
              <Link to={"/blog/" + blog.slug} style={{ display: "flex", textDecoration: "none" }}>
                {blog.image ? (
                  <img
                    src={PUBLIC_URL(blog.image)}
                    alt={blog.title}
                    style={{
                      width: 50,
                      height: 50,
                      objectFit: "cover",
                      borderRadius: 6,
                      marginRight: 10,
                      flexShrink: 0,
                    }}
                  />
                ) : (
                  <div style={{
                    width: 50,
                    height: 50,
                    backgroundColor: "#f5f5f5",
                    borderRadius: 6,
                    marginRight: 10,
                    flexShrink: 0,
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                  }}>
                    <i className="fas fa-pencil-alt" style={{ color: "#ccc", fontSize: 12 }}></i>
                  </div>
                )}
                <div>
                  <p style={{
                    fontSize: 13,
                    fontWeight: 600,
                    color: "#333",
                    marginBottom: 3,
                    lineHeight: 1.3,
                  }}>
                    {blog.title}
                  </p>
                  <small style={{ color: "#999", fontSize: 11 }}>{this.formatDate(blog.created_at)}</small>
                </div>
              </Link>
            </div>
          );
        }.bind(this))}
        <Link to="/blog" style={{
          color: "#88c000",
          fontSize: 13,
          fontWeight: 600,
          textDecoration: "none",
        }}>
          Tüm Yazıları Gör &rarr;
        </Link>
      </div>
    );
  }
}

var mapStateToProps = function(state) {
  return { blog: state.blog };
};
var mapDispatchToProps = { getRecentBlogs: getRecentBlogs };

export default connect(mapStateToProps, mapDispatchToProps)(BlogWidget);



// WEBPACK FOOTER //
// ./src/components/shared/BlogWidget.js